/**
 * 모델
 * @window w_tb_e045_03
 * @category 사전점검등록(점검일지)
 */
export default class JournalGridModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 오류갯수
   *
   * **data type** varchar(8)
   */
  readonly aa_error: string;

  /**
   * 현장코드
   *
   * **data type** varchar(8)
   */
  readonly actcd: string;

  /**
   * 호기코드
   *
   * **data type** varchar(8)
   */
  readonly equpcd: string;

  /**
   * 종류
   *
   * **data type** varchar(8)
   */
  readonly evcd: string;

  /**
   * 분류
   *
   * **data type** varchar(8)
   */
  readonly gkccd: string;

  /**
   * 분류명
   *
   * **data type** varchar(8)
   */
  readonly gkcnm: string;

  /**
   * 항목번호
   *
   * **data type** varchar(8)
   */
  readonly gresultcd: string;

  /**
   * 구분
   *
   * **data type** varchar(8)
   */
  readonly gubun: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  readonly indate: string;

  /**
   * 입력자
   *
   * **data type** varchar(8)
   */
  readonly inperid: string;

  /**
   * 비고
   *
   * **data type** varchar(8)
   */
  readonly remark: string;

  /**
   * 결과코드
   *
   * **data type** varchar(8)
   */
  readonly resultcd: string;

  /**
   * 결과명
   *
   * **data type** varchar(8)
   */
  readonly resultnm: string;

  /**
   * 순서
   *
   * **data type** varchar(8)
   */
  readonly seq: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(8)
   */
  readonly spjangcd: string;

  /**
   * 상태
   *
   * **data type** varchar(8)
   */
  readonly state: string;

  /**
   * 상태2
   *
   * **data type** varchar(8)
   */
  readonly state2: string;

  /**
   * 상태명
   *
   * **data type** varchar(8)
   */
  readonly statenm: string;


  constructor(data: any = {}) {
    this.custcd = data.custcd || '';
    this.aa_error = data.aa_error || '';
    this.actcd = data.actcd || '';
    this.equpcd = data.equpcd || '';
    this.evcd = data.evcd || '';
    this.gkccd = data.gkccd || '';
    this.gkcnm = data.gkcnm || '';
    this.gresultcd = data.gresultcd || '';
    this.gubun = data.gubun || '';
    this.indate = data.indate || '';
    this.inperid = data.inperid || '';
    this.remark = data.remark || '';
    this.resultcd = data.resultcd || '';
    this.resultnm = data.resultnm || '';
    this.seq = data.seq || '';
    this.spjangcd = data.spjangcd || '';
    this.state = data.state || '';
    this.state2 = data.state2 || '';
    this.statenm = data.statenm || '';
  }
}
